import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

interface Props {
	payment: { amount: number; interval: any; paymentType: any };
}

export default /*@__PURE__*/_defineComponent({
  __name: 'DonationSummaryHeadline',
  props: {
    payment: {}
  },
  setup(__props: any) {

const props = __props;
const { t, n } = useI18n();

const formattedAmount = computed( () => n( props.payment.amount, { key: 'currency', currencyDisplay: 'name' } ) );

const interval = computed( () => props.payment.interval ? t( 'donation_form_payment_interval_' + props.payment.interval ) : '' );

const paymentType = computed( () => props.payment.paymentType ? t( props.payment.paymentType ) : '' );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", null, [
    _createTextVNode(_toDisplayString(_ctx.$t( 'donation_form_summary_headline' )) + " " + _toDisplayString(formattedAmount.value) + " ", 1),
    (interval.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createTextVNode(_toDisplayString(interval.value), 1)
        ], 64))
      : _createCommentVNode("", true),
    (paymentType.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createTextVNode(_toDisplayString(_ctx.$t('donation_summary_via')) + " " + _toDisplayString(paymentType.value), 1)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})